import {
  Box,
  Card,
  Checkbox,
  Divider,
  List,
  ListItem,
  makeStyles,
  Popover,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  withStyles,
  Fade,
  useTheme,
  useMediaQuery
} from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { Pagination } from '@material-ui/lab';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { useSelector } from 'react-redux';
import DialogConfirm from 'src/app/components/DialogConfirm';
import { MESSAGE } from 'src/app/constant/message';
import { closeDialogConfirm, showDialogConfirm } from 'src/features/uiSlice';
import { useQuery } from 'src/app/hooks/useQuery';
import { useDragScroll } from 'src/app/hooks/useDragScroll';

import { useDispatch } from 'react-redux';
import { PAGE_SIZE_LIST } from 'src/app/constant/config';
import { deleteMultiUsers, resetPasswordCustomer } from 'src/features/userSlice';
import EditUserForm from './EditUser';
import AgencyAccountInfoDialog from '../agency/AgencyAccountInfoDialog';
import moment from 'moment';

const DEFAULT_RESET_PASSWORD = '123456';

const CHECKBOX_COL_WIDTH = 56;
const PHONE_COL_WIDTH = 150;
const NAME_COL_WIDTH = 250;

const COLUMN_WIDTHS = [
  CHECKBOX_COL_WIDTH, // Checkbox
  PHONE_COL_WIDTH, // Số điện thoại
  NAME_COL_WIDTH, // Tên khách hàng
  200, // Tên đăng nhập
  100, // Vai trò
  100, // Trạng thái
  200, // Email
  400, // Địa chỉ
  150, // Tỉnh thành
  150, // Người tạo
  200, // Ngày tạo
  80 // Hành động
];

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
    whiteSpace: 'nowrap'
  },
  body: {
    fontSize: 14,
    wordBreak: 'break-word'
  },
  root: {
    padding: '6px'
  }
}))(TableCell);

const Results = ({ className, listUsers, getListUsersRef, currentParams }) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const dragScrollRef = useDragScroll();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const limit = isMobile ? 6 : PAGE_SIZE_LIST;
  const [selectedItem, setSelectedItem] = useState();
  const [itemCurrent, setItemCurrent] = useState();
  const totalUsers = useSelector(state => state.userSlice.totalUsers);
  const listProvinces = useSelector(state => state.provinceSlice.listProvinces);
  const isCustomerCare = useSelector(state => state.authSlice.isCustomerCare);
  const [rowsSelected, setRowsSelected] = useState([]);
  const [isScrolledX, setIsScrolledX] = useState(false);
  const stickyCheckboxClass = isScrolledX ? classes.stickyCheckbox : undefined;
  const stickyPhoneClass = isScrolledX ? classes.stickyPhone : undefined;
  const stickyNameClass = isScrolledX ? classes.stickyName : undefined;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [confirmType, setConfirmType] = useState(null);
  const [showAccountInfo, setShowAccountInfo] = useState(false);
  const [accountInfo, setAccountInfo] = useState(null);

  const [params, setParams] = useState({
    page: currentParams?.page || 1,
    page_size: limit
  });

  const query = useQuery();

  useEffect(() => {
    if (currentParams) {
      setParams({
        ...currentParams,
        page: currentParams?.page || 1,
        page_size: currentParams?.page_size || PAGE_SIZE_LIST
      });
    }
  }, [currentParams]);

  useEffect(() => {
    const pageFromQuery = query.get('page');
    const pageSizeFromQuery = query.get('page_size');

    if (pageFromQuery) {
      setParams(prev => ({
        ...prev,
        page: Number(pageFromQuery)
      }));
    }
    if (pageSizeFromQuery) {
      setParams(prev => ({
        ...prev,
        page_size: Number(pageSizeFromQuery)
      }));
    }
  }, [query]);

  const handleClickMenu = (event, user) => {
    setAnchorEl(event.currentTarget);
    setItemCurrent({
      id: user.id,
      username: user.username,
      full_name: user.full_name,
      email: user.email,
      phone: user.phone,
      citizen_id: user.citizen_id,
      address: user.address,
      status: user.status
    });
    setSelectedItem(user.id);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);

  const closeModal = () => {
    setOpenEditModal(false);
  };

  const handleDeleteMember = () => {
    setConfirmType('delete');
    dispatch(showDialogConfirm());
    handleCloseMenu();
  };

  const handleDeleteMultiUsers = () => {
    setConfirmType('delete');
    dispatch(showDialogConfirm());
    handleCloseMenu();
  };

  const handleResetPassword = () => {
    setConfirmType('reset-password');
    dispatch(showDialogConfirm());
    handleCloseMenu();
  };

  const confirmDelete = () => {
    const listId = rowsSelected.length > 0 ? rowsSelected : [selectedItem];
    setRowsSelected([]);
    setConfirmType(null);
    dispatch(closeDialogConfirm());
    dispatch(deleteMultiUsers({ user_ids: listId }));
  };

  const confirmResetPassword = () => {
    setConfirmType(null);
    dispatch(closeDialogConfirm());
    const resetUsername = itemCurrent?.username || itemCurrent?.phone;
    dispatch(resetPasswordCustomer({ id: selectedItem })).then(action => {
      if (resetPasswordCustomer.fulfilled.match(action)) {
        setAccountInfo({
          username: resetUsername,
          password: DEFAULT_RESET_PASSWORD
        });
        setShowAccountInfo(true);
      }
    });
  };

  const handleCloseDialogConfirm = () => {
    setConfirmType(null);
    dispatch(closeDialogConfirm());
  };

  const handleEditUser = () => {
    setOpenEditModal(true);
    handleCloseMenu();
  };

  const handlePageChange = (event, newPage) => {
    if (!getListUsersRef) return;
    const newparams = {
      ...currentParams,
      page: newPage,
      page_size: limit
    };
    setParams(newparams);
    getListUsersRef(newparams);
  };

  const checked = id => {
    return rowsSelected.indexOf(id) !== -1;
  };

  const select = driver => {
    if (rowsSelected.indexOf(driver) === -1) {
      const newSelected = [driver, ...rowsSelected];
      setRowsSelected(newSelected);
    } else {
      const newSelected = rowsSelected.filter(i => i !== driver);
      setRowsSelected(newSelected);
    }
  };

  const checkAll = () => {
    if (rowsSelected.length > 0) {
      setRowsSelected([]);
    }

    if (listUsers.length > 0 && rowsSelected.length !== listUsers.length) {
      const all = listUsers.map(item => {
        return item.id;
      });
      setRowsSelected(all);
    }
  };

  const getStatus = status => {
    const statusUser = {
      1: 'Hoạt động',
      0: 'Tạm dừng'
    };
    return statusUser[status];
  };

  const getProvinceAddress = citizenId => {
    const province = listProvinces?.find(
      province => province.id === +citizenId
    );
    return province?.name;
  };

  return (
    <>
      {openEditModal && (
        <EditUserForm open userSelected={itemCurrent} onClose={closeModal} />
      )}

      <AgencyAccountInfoDialog
        open={showAccountInfo}
        onClose={() => setShowAccountInfo(false)}
        accountInfo={accountInfo}
        type="customer"
      />

      <DialogConfirm
        title={
          confirmType === 'reset-password'
            ? MESSAGE.CONFIRM_RESET_PASSWORD_USER
            : MESSAGE.CONFIRM_DELETE_USER
        }
        textOk={MESSAGE.BTN_YES}
        textCancel={MESSAGE.BTN_CANCEL}
        content={
          confirmType === 'reset-password'
            ? MESSAGE.CONTENT_RESET_PASSWORD_USER
            : MESSAGE.CONTENT_DELETE_USER
        }
        callbackOk={
          confirmType === 'reset-password'
            ? confirmResetPassword
            : confirmDelete
        }
        callbackCancel={handleCloseDialogConfirm}
      />

      <Card className={clsx(classes.root, className)}>
        <div>
          {rowsSelected.length > 0 && !isCustomerCare && (
            <Fade in={rowsSelected.length > 0}>
              <Box style={{ overflowX: 'auto', padding: '6px' }} minWidth={1050}>
                <span>
                  <Checkbox
                    checked={rowsSelected.length > 0}
                    onChange={() => checkAll()}
                    color="primary"
                    inputProps={{ 'aria-label': 'secondary checkbox' }}
                  />
                </span>

                <span
                  onClick={handleDeleteMultiUsers}
                  className="mx-2 btnDevice"
                  color="primary"
                  variant="outlined"
                  size="small"
                >
                  <img
                    src={`/static/iconSvg/delete-icon.svg`}
                    alt="delete"
                    style={{ paddingRight: '5px', paddingBottom: '4px' }}
                  />
                  <span className="pt-1"> Xóa </span>
                </span>
              </Box>
            </Fade>
          )}
          <PerfectScrollbar >
            {listUsers && listUsers.length > 0 ? (
              <Box
                ref={dragScrollRef}
                className={clsx(classes.tableScroll, classes.dragScroll)}
                minWidth={1050}
                onScroll={e => setIsScrolledX(e.currentTarget.scrollLeft > 0)}
              >
                <Table>
                  <colgroup>
                    {COLUMN_WIDTHS.map((width, index) => (
                      <col key={index} style={{ width, minWidth: width }} />
                    ))}
                  </colgroup>
                  {rowsSelected.length === 0 && listUsers?.length > 0 && (
                    <TableHead>
                      <TableRow>
                        <StyledTableCell
                          className={clsx(classes.checkboxCell, stickyCheckboxClass)}
                          style={{ zIndex: 3 }}
                        >
                          <Checkbox
                            checked={rowsSelected.length > 0}
                            onChange={() => checkAll()}
                            color="primary"
                            inputProps={{
                              'aria-label': 'secondary checkbox'
                            }}
                          />
                        </StyledTableCell>
                        <StyledTableCell
                          className={clsx(classes.phoneCell, stickyPhoneClass)}
                          style={{ zIndex: 3 }}
                        >
                          Số điện thoại
                        </StyledTableCell>
                        <StyledTableCell className={stickyNameClass} style={{ zIndex: 3 }}>
                          Tên khách hàng
                        </StyledTableCell>
                        <StyledTableCell width={200}>Tên đăng nhập</StyledTableCell>
                        <StyledTableCell width={100}>Vai trò</StyledTableCell>
                        <StyledTableCell width={100}>Trạng thái</StyledTableCell>
                        <StyledTableCell width={200}>Email</StyledTableCell>
                        <StyledTableCell width={400}>Địa chỉ</StyledTableCell>
                        <StyledTableCell width={150}>Tỉnh thành</StyledTableCell>
                        <StyledTableCell width={150}>Người tạo</StyledTableCell>
                        <StyledTableCell width={200}>Ngày tạo</StyledTableCell>
                        <StyledTableCell className={classes.stickyAction} style={{ zIndex: 3 }}>
                          Hành động
                        </StyledTableCell>
                      </TableRow>
                    </TableHead>
                  )}
                  <TableBody>
                    {listUsers.map((user, index) => (
                      <TableRow hover key={user.id}>
                        <StyledTableCell
                          className={clsx(classes.checkboxCell, stickyCheckboxClass)}
                          style={{ backgroundColor: '#fff' }}
                          onClick={() => select(user?.id)}
                        >
                          <Checkbox
                            checked={checked(user.id)}
                            onChange={() => select(user.id)}
                            color="primary"
                            inputProps={{
                              'aria-label': 'secondary checkbox'
                            }}
                          />
                        </StyledTableCell>
                        <StyledTableCell
                          className={clsx(classes.phoneCell, stickyPhoneClass)}
                          style={{ backgroundColor: '#fff' }}
                        >
                          {user?.phone || '--'}
                        </StyledTableCell>
                        <StyledTableCell className={stickyNameClass} style={{ backgroundColor: '#fff' }}>
                          {user?.full_name || '--'}
                        </StyledTableCell>
                        <StyledTableCell>
                          {user?.username || '--'}
                        </StyledTableCell>
                        <StyledTableCell>
                          {user?.role.title || '--'}
                        </StyledTableCell>
                        <StyledTableCell>
                          {getStatus(user?.status) || '--'}
                        </StyledTableCell>
                        <StyledTableCell>
                          {user?.email || '--'}
                        </StyledTableCell>
                        <StyledTableCell>
                          {user?.address || '--'}
                        </StyledTableCell>
                        <StyledTableCell>
                          {getProvinceAddress(user?.citizen_id) || '--'}
                        </StyledTableCell>
                        <StyledTableCell>
                          {user?.userCreated?.full_name || user?.userCreated?.username || '--'}
                        </StyledTableCell>
                        <StyledTableCell>
                          {user?.created_at
                            ? moment(user?.created_at).format(
                              'HH:mm:ss DD-MM-yyyy'
                            )
                            : '--'}
                        </StyledTableCell>
                        <StyledTableCell className={classes.stickyAction} style={{ backgroundColor: '#fff' }}>
                          <span style={{ color: '#AEB1C5' }}>
                            <MoreVertIcon
                              aria-describedby={`menu-device-${user.id}`}
                              className={`cursor-pointer hover-red`}
                              onClick={e => handleClickMenu(e, user)}
                            />
                          </span>

                          <Popover
                            className="popover-device"
                            open={open}
                            anchorEl={anchorEl}
                            onClose={handleCloseMenu}
                            anchorOrigin={{
                              vertical: 'bottom',
                              horizontal: 'left'
                            }}
                            transformOrigin={{
                              vertical: 'top',
                              horizontal: 'right'
                            }}
                          >
                            <Typography>
                              <List>
                                <ListItem
                                  className="cursor-pointer list-menu-device"
                                  onClick={handleResetPassword}>
                                  <span> Reset mật khẩu </span>
                                </ListItem>
                                <Divider />
                                <ListItem
                                  onClick={handleEditUser}
                                  className="cursor-pointer list-menu-device"
                                >
                                  <span> Chỉnh sửa </span>
                                </ListItem>
                                {!isCustomerCare && (
                                  <>
                                    <Divider />
                                    <ListItem
                                      onClick={handleDeleteMember}
                                      className="cursor-pointer list-menu-device"
                                    >
                                      <span class="text-danger"> Xóa </span>
                                    </ListItem>
                                  </>
                                )}
                              </List>
                            </Typography>
                          </Popover>
                        </StyledTableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            ) : (
              <div className="text-center pb-5">
                <img src="/static/empty.png" class="justify-content-center" />
                <h5>
                  {isCustomerCare && !currentParams?.keywords
                    ? 'Vui lòng nhập tên, số điện thoại hoặc email để tìm kiếm'
                    : 'Danh sách trống'}
                </h5>
              </div>
            )}
          </PerfectScrollbar>
        </div>
      </Card>
      {listUsers && listUsers.length > 0 && (
        <div class="mt-3 mr-4 float-right">
          <Box
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '15px'
            }}
          >
            <Typography style={{ fontSize: '14px' }}>
              Tổng: {totalUsers}
            </Typography>
            <Pagination
              count={Math.ceil(totalUsers / limit)}
              color="primary"
              size="small"
              onChange={handlePageChange}
              page={Number(params.page) || 1}
              siblingCount={isMobile ? 0 : 1}
              boundaryCount={isMobile ? 1 : 2}
              showFirstButton={!isMobile}
              showLastButton={!isMobile}
            />
          </Box>
        </div>
      )}
    </>
  );
};

Results.propTypes = {
  className: PropTypes.string,
  listUser: PropTypes.array.isRequired,
  currentParams: PropTypes.object
};

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    '&.MuiPaper-elevation1': {
      boxShadow: 'none'
    }
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  groupAction: {
    display: 'flex',
    alignItems: 'center',
    '& .action': {
      cursor: 'pointer',
      padding: '0 5px',
      '&:hover': {
        color: '#3f51b5'
      }
    }
  },

  checkboxCell: {
    boxSizing: 'border-box',
    width: CHECKBOX_COL_WIDTH,
    minWidth: CHECKBOX_COL_WIDTH,
    maxWidth: CHECKBOX_COL_WIDTH
  },
  
  phoneCell: {
    boxSizing: 'border-box',
    width: PHONE_COL_WIDTH,
    minWidth: PHONE_COL_WIDTH,
    maxWidth: PHONE_COL_WIDTH
  },
  stickyCheckbox: {
    position: 'sticky',
    left: 0,
    zIndex: 2
  },
  stickyPhone: {
    position: 'sticky',
    left: CHECKBOX_COL_WIDTH,
    zIndex: 2
  },
  stickyName: {
    position: 'sticky',
    left: CHECKBOX_COL_WIDTH + PHONE_COL_WIDTH,
    zIndex: 2,
    boxShadow: 'inset -1px 0 0 #dcdfe6, 8px 0 10px -6px rgba(0, 0, 0, 0.22)'
  },
  stickyAction: {
    position: 'sticky',
    right: 0,
    zIndex: 2,
    textAlign: 'center',
    boxShadow: 'inset 1px 0 0 #dcdfe6, -8px 0 10px -6px rgba(0, 0, 0, 0.22)'
  },
  dragScroll: {
    cursor: 'grab'
  },
  tableScroll: {
    overflowX: 'auto',
    scrollbarWidth: 'auto',
    scrollbarColor: '#d0d0d0 #f7f7f7',
    '&::-webkit-scrollbar': {
      height: '14px'
    },
    '&::-webkit-scrollbar-track': {
      background: '#f7f7f7',
      borderRadius: '7px'
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#d0d0d0',
      borderRadius: '7px',
      border: '3px solid #f7f7f7',
      minWidth: '60px',
      cursor: 'pointer',
      '&:hover': {
        background: '#b5b5b5'
      },
      '&:active': {
        background: '#a0a0a0'
      }
    }
  },
  minWithColumn: {
    minWidth: '150px'
  }
}));

export default Results;
